/* unplugin-vue-components disabled */import { render } from "./quaHonor.vue?vue&type=template&id=ba3abea4&scoped=true"
import script from "./quaHonor.vue?vue&type=script&lang=js"
export * from "./quaHonor.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=ba3abea4&lang=less&scoped=true"
import "../../assets/css/about/about.less?vue&type=style&index=1&id=ba3abea4&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba3abea4"]])

export default __exports__